import React from "react";
import {GeneralActions, GeneralContainer, GeneralFormColumnWrapper, GeneralFormContainer} from "./General.styled";
import Header from "../Header/Header";
import {RoundedButton} from "../../../../../elements";
import {LabelForm} from "../../../PromptManagementSystemPage/components/FormPrompt/FormPrompt.styled";
import TextInput from "../../../../../elements/v2/TextInput/TextInput";
import TextArea from "../../../../../elements/v2/TextArea/TextArea";

const General = ({ onNext }) => {
  const [ruleName, setRuleName] = React.useState("");
  const [ruleDescription, setDescriptionName] = React.useState("");
  
  const onHandleRuleNameChange = (e) => {
    setRuleName(e.target.value);
  };
  
  const onHandleDescriptionChange = (e) => {
    setDescriptionName(e.target.value);
  }
  
  return (
    <GeneralContainer>
      <Header
        title="Set When and to Whom This Rule Applies"
        description="Use the fields below to specify the criteria that activate this suppression rule."
        textAlign="left"
        headerSize="14px"
      />
      <GeneralFormContainer>
        <GeneralFormColumnWrapper>
          <LabelForm>Rule Name</LabelForm>
          <TextInput
            type="text"
            value={ruleName}
            onChange={onHandleRuleNameChange}
            placeholder="e.g. Limit outreach to recent buyers"
            width={"100%"}
          />
        </GeneralFormColumnWrapper>
        <GeneralFormColumnWrapper>
          <LabelForm>Description (Optional)</LabelForm>
          <TextArea
            type="text"
            value={ruleDescription}
            onChange={onHandleDescriptionChange}
            placeholder="Explain when or why this rule should apply"
            width={"100%"}
            height={"144px"}
          />
        </GeneralFormColumnWrapper>
      </GeneralFormContainer>
      <GeneralActions>
        <RoundedButton
          width="78px"
          height="40px"
          kind={"primary"}
          outline={true}
          fontWeight="normal"
          fontSize="14px"
          margin="0"
          borderRadius="8px"
          onClick={() => {}}
        >
          Cancel
        </RoundedButton>
        <RoundedButton
          width="64px"
          height="40px"
          kind={"confirm"}
          fontWeight="normal"
          fontSize="14px"
          margin="0"
          borderRadius="8px"
          onClick={onNext}
        >
          Save
        </RoundedButton>
      </GeneralActions>
    </GeneralContainer>
  );
};

export default General; 